import { Action } from '@ngrx/store';

export const SET_APPLYING_BONUS = '[Checkout] Set applying bonus';
export const RESET_APPLYING_BONUS = '[Checkout] Reset applying bonus';

export class SetApplyingBonus implements Action {
  readonly type = SET_APPLYING_BONUS;

  constructor(public payload: number) {}
}

export class ResetApplyingBonus implements Action {
  readonly type = RESET_APPLYING_BONUS;

  constructor() {}
}

export type ApplyingBonusActions = SetApplyingBonus | ResetApplyingBonus;
